module.exports = __webpack_public_path__ + "static/media/UploadSources.8db17485.svg";